<template lang="pug">
    div
        congrats
</template>

<script>
    import Congrats from './Congrats';

    export default {
        components: {
            Congrats
        }
    };
</script>
